export const initProductModelRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/product-models",
          name: "product-model",
          component: () => import("@/pages/manage/product-models/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/product-models/:id",
          name: "product-model-id",
          component: () => import("@/pages/manage/product-models/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
